import * as React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';

const useStyles = makeStyles((theme: Theme) => ({
  checkbox: {
    marginTop: 16,
  },
}));

export const RoomEditCheckBox = (props: {
  value: boolean | undefined;
  name: string;
  label?: string;
  helperText?: string;
  className?: string;
  onChange: (value: boolean, name: string, error: string) => any;
}) => {
  const { onChange } = props;
  const classes = useStyles();

  return (
    <FormControl variant="filled" className={props.className}>
      <InputLabel shrink={true} className="CheckBoxerLabel">
        {props.label}
      </InputLabel>
      <Checkbox
        className={clsx(classes.checkbox)}
        checked={props.value}
        onChange={React.useCallback(
          (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked, props.name, ''),
          [onChange, props.name]
        )}
        name={props.name}
      />
      <FormHelperText>{props.helperText}</FormHelperText>
    </FormControl>
  );
};
